import { createPolymorphicComponent, NavLink, NavLinkProps } from '@mantine/core';
import { forwardRef } from 'react';

import styles from './NavItem.module.css';
import { joinClassNames } from 'utils/joinClassNames';

export type NavItemProps = NavLinkProps;

const _NavItem = forwardRef<HTMLAnchorElement, NavItemProps>(({ className, ...others }, ref) => (
    <NavLink {...others} ref={ref} className={joinClassNames(styles.navItem, className)}></NavLink>
));

_NavItem.displayName = 'NavItem';

const NavItem = createPolymorphicComponent<'a', NavItemProps>(_NavItem);

export { NavItem };
